import * as React from 'react';

import MemberEditForm from '../../components/form/member-edit-form';

const addMember: React.FC<{ match: { params: { orgId } } }> = ({ match }) => {
  const { orgId } = match.params;

  return (
    <div id="add-member" className="container hub-full-width">
      <div className="u-xs-padXl u-flexExpandSides">
        <MemberEditForm orgId={+orgId} />
      </div>
    </div>
  );
};

export default addMember;
